import type { CountryDetails } from '@components/LocaleSwitcher'
import {
  LANGUAGE_LABELS,
  COUNTRIES_DETAILS,
  COUNTRIES_LABELS,
  type CountryCodes,
  type LanguageCodes,
  type UrlsPerCountry,
  brazilUrl,
} from '@constants/countryDetails'

export const getLanguageSwitcherProps = (
  urls: UrlsPerCountry,
  countryCode: CountryCodes
) => {
  type LocalizedUrl = {
    url: string
    contentfulLanguageLabel: string
    languageCode: LanguageCodes
  }
  type LanguageSwitcherProps = Record<CountryCodes, LocalizedUrl[]>

  const languageSwitcherProps = {} as LanguageSwitcherProps
  Object.keys(COUNTRIES_DETAILS).forEach(key => {
    languageSwitcherProps[key as CountryCodes] = []
  })

  Object.keys(urls).forEach(country => {
    const countryTyped = country as CountryCodes

    languageSwitcherProps[countryTyped] = urls[countryTyped].map(
      (url: string, index: number) => {
        const language = url.substring(1, 3) as LanguageCodes

        return {
          url,
          contentfulLanguageLabel: LANGUAGE_LABELS[language],
          languageCode: language,
        }
      }
    )
  })

  // always render English button first
  if (languageSwitcherProps[countryCode][0].languageCode !== 'en') {
    languageSwitcherProps[countryCode].reverse()
  }

  return languageSwitcherProps[countryCode]
}

export const getCountrySwitcherProps = (
  urls: UrlsPerCountry
): CountryDetails[] => {
  const countrySwitcherData = Object.keys(urls).map(country => {
    const countryTyped = country as CountryCodes
    const altIndex = urls[countryTyped][0].substring(1, 3) === 'en' ? 0 : 1

    let url =
      urls[countryTyped].length > 1
        ? urls[countryTyped][altIndex === 0 ? 1 : 0]
        : urls[countryTyped][0]

    let altUrl = urls[countryTyped][altIndex]

    // overiding the brazil url
    if (countryTyped === 'br') {
      url = brazilUrl
      altUrl = brazilUrl
    }

    return {
      countryCode: countryTyped,
      name: COUNTRIES_LABELS[countryTyped],
      FlagIcon: COUNTRIES_DETAILS[countryTyped].FlagIcon,
      url,
      altUrl,
    }
  })

  return countrySwitcherData
}
